'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fat';
var iconName = 'compass-drafting';
var width = 512;
var height = 512;
var aliases = ["drafting-compass"];
var unicode = 'f568';
var svgPathData = 'M320 80A64 64 0 1 0 192 80a64 64 0 1 0 128 0zm-22.7 68.5C285.3 155.8 271.1 160 256 160s-29.3-4.2-41.3-11.5l-88.9 160c37.4 22.6 81.2 35.5 128 35.5c91.8 0 171.9-49.9 214.8-124c2.2-3.8 7.1-5.1 10.9-2.9s5.1 7.1 2.9 10.9c-45.6 78.9-130.9 132-228.7 132c-49.6 0-96.1-13.7-135.8-37.5L15 507.9c-2.1 3.9-7 5.3-10.9 3.1s-5.3-7-3.1-10.9L104.5 313.8C72.1 291.5 44.8 262.2 25.1 228c-2.2-3.8-.9-8.7 2.9-10.9s8.7-.9 10.9 2.9c18.3 31.7 43.5 58.9 73.4 79.8L201 140.1l.7-1.3C185.9 124.2 176 103.2 176 80c0-44.2 35.8-80 80-80s80 35.8 80 80c0 23.2-9.9 44.2-25.7 58.8l.7 1.3 62.2 112c2.1 3.9 .8 8.7-3.1 10.9s-8.7 .8-10.9-3.1L297.3 148.5zM421.5 371.9c-2.1-3.9-.8-8.7 3.1-10.9s8.7-.8 10.9 3.1l75.6 136c2.1 3.9 .8 8.7-3.1 10.9s-8.7 .8-10.9-3.1l-75.6-136z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCompassDrafting = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;